import { useCallback, useState } from 'react';
import { ApiError } from './api';

interface FormErrors {
  /** Feldbezogene Meldungen, wie sie der Server zurückgibt. */
  fields: Record<string, string>;
  /** Meldung, die zu keinem einzelnen Feld gehört. */
  general: string | null;
}

const EMPTY: FormErrors = { fields: {}, general: null };

/**
 * Übernimmt die Feldfehler des Servers ins Formular. Die Prüfung liegt damit
 * an einer Stelle — es gibt keine zweite, abweichende Regelsammlung im Frontend.
 */
export function useFormErrors() {
  const [errors, setErrors] = useState<FormErrors>(EMPTY);

  const capture = useCallback((error: unknown) => {
    if (error instanceof ApiError) {
      const hasFieldErrors = Object.keys(error.details).length > 0;
      setErrors({
        fields: error.details,
        general: hasFieldErrors ? null : error.message,
      });
      return;
    }
    setErrors({ fields: {}, general: 'Unerwarteter Fehler. Bitte erneut versuchen.' });
  }, []);

  const clear = useCallback(() => setErrors(EMPTY), []);

  return { errors, capture, clear, fieldError: (name: string) => errors.fields[name] };
}
